module.exports = __webpack_public_path__ + "static/media/YF83_6.28b71a71.jpg";